export default __webpack_public_path__ + "static/media/14JulyImg.228ebfbc.png";